import React from 'react'
import curvedBackground from "../assect/images/bg/dl_curvedimg_listings.png";

export default function PageHeader(props) {
    return (
        <div className="top-half top-half d-table w-100 pt-5">
            <section className="bg-half-116" style={{ backgroundImage: `url(${curvedBackground})` }}>
            </section>
        </div>);
}
